
import { defineComponent } from 'vue';
import KeycloakService from '@/services/keycloak/keycloakService';
import { getRoles } from '@/services/config';
import { mapGetters } from 'vuex';
import UserService from '@/views/Users/user.service';
const userService = new UserService();

export default defineComponent({
  name: 'Navbar',
  data() {
      return {
          menus:[
            {
              title_key: "menu.org",
              link: "/organizations",
              roles: "ADMIN_IOSI"
            },
            {
              title_key: "menu.user",
              link: "/users",
              roles: "ADMIN_IOSI,ADMIN"
            },
            {
              title_key: "menu.license",
              link: "/licenses",
              roles: "ADMIN_IOSI,ADMIN"
            },

            {
              title_key: "menu.computer",
              link: "/computers",
              roles: "ADMIN_IOSI,ADMIN"
            },
          ],

          scheduleItems: [
            {
              title_key: "menu.group",
              link: "/groups",
              icon: "groups",
              roles: "ADMIN_IOSI,AMDIN"
            },
            {
              title_key: "menu.allocation",
              link: "/schedule",
              icon: "computer",
              roles: "ADMIN_IOSI,ADMIN"
            }
          ],

          clientMenu: [
            {
              title_key: "menu.schedule",
              link: "/agendamento",
            },
            {
              title_key: "menu.buyCredits",
              link: "/comprar-horas",
            }
          ],

          userMenu:[
            {
              title_key: "menu.schedule",
              link: "/agendamento",
            },
          ],

          roles: getRoles(),
          userInfo: {} as any,
          userOrgId: "" as string,
      };
  },

  computed: {
    ...mapGetters({
            storeUserInfo: "users/getUserInfo",
        }),
  },

  methods:{
    redirect(){
      switch(this.roles){
        case 'ADMIN':
          this.goTo('/users');
          break;
        case 'ADMIN_IOSI':
          this.goTo('/organizations');
          break;
        case 'USER':
        case 'CLIENT':
          this.goTo('/agendamento');
          break;
        default:
          this.goTo('/');
          break;
      }
    },
    async getUserInfo(){
      userService.getUserInfo().then(() => {
        this.userInfo = this.storeUserInfo;
        this.userOrgId = this.userInfo.organization.id;
      });
    },

    checkRoles(): Array<{link: string; title_key: string; roles: string;}>{
      const session = this.roles;

      let activeMenus = [] as Array<{link: string; title_key: string; roles: string;}>;

      this.menus.forEach((menu) => {
        if(menu.roles){
          const roles = menu.roles as string;
          let arrayRoles = roles.split(',')
          const check = arrayRoles.find(
            (role: string) => role == session
          );
          check ? activeMenus.push(menu) : undefined
        }
      });

      return activeMenus
    },

    goTo(link: string){
        this.$router.push(link);
    },

    isActive(link: string){
      return this.$route.path.includes(link);
    },

    login(){
      KeycloakService.CallLogin("/redirect");
    },

    logout(){
      KeycloakService.CallLogout("/");
    }
  },

  mounted(){
    this.getUserInfo();
  }

});
